<template>
  <div v-if="splitTracking" class="split-tracking-badge">
    <a 
      :href="splitTicketUrl" 
      target="_blank" 
      class="badge badge-info d-inline-flex align-items-center"
      :title="`Split to ticket #${splitTracking.split_to_ticket_id} on ${displaySplitTime}`"
    >
      <i class="fa fa-code-branch mr-1"></i>
      <span class="split-text">Split to #{{ splitTracking.split_to_ticket_id }}</span>
      <i class="fa fa-external-link-alt ml-1" style="font-size: 10px;"></i>
    </a>
  </div>
</template>

<script>
import Dates from "../mixins/Dates";

export default {
  name: "SplitTrackingBadge",
  mixins: [Dates],
  props: {
    splitTracking: {
      type: Object,
      required: true,
      validator: function (value) {
        return value && 
               typeof value.split_to_ticket_id === 'number' && 
               typeof value.split_at === 'string' && 
               typeof value.split_by_user_id === 'number';
      }
    }
  },
  computed: {
    splitTicketUrl() {
      return `/tickets/${this.splitTracking.split_to_ticket_id}`;
    },
    displaySplitTime() {
      return this.displayTimestamp(this.splitTracking.split_at);
    }
  }
};
</script>

<style lang="scss" scoped>
.split-tracking-badge {
  display: block;
  margin-top: 4px;
  
  .badge {
    font-size: 10px;
    padding: 4px 8px;
    border-radius: 12px;
    text-decoration: none;
    background-color: #17a2b8;
    color: white;
    border: 1px solid transparent;
    
    &:hover {
      background-color: #138496;
      color: white;
      text-decoration: none;
    }
    
    &:focus {
      outline: none;
      box-shadow: 0 0 0 2px rgba(23, 162, 184, 0.25);
    }
    
    .split-text {
      font-weight: 500;
      letter-spacing: 0.3px;
    }
    
    i {
      opacity: 0.9;
    }
  }
}

// Dark theme support
@media (prefers-color-scheme: dark) {
  .split-tracking-badge .badge {
    background-color: #20c997;
    border-color: #20c997;
    
    &:hover {
      background-color: #1aa179;
      border-color: #1aa179;
    }
  }
}
</style>
